import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Parte } from "src/app/common/models/parte";
import { Argomento } from "src/app/common/models/tipologiche/argomento";
import { AutoritaGiudiziaria } from "src/app/common/models/tipologiche/autorita-giudiziaria";
import { Categoria } from "src/app/common/models/tipologiche/categoria";
import { Comune } from "src/app/common/models/tipologiche/comune";
import { Grado } from "src/app/common/models/tipologiche/grado";
import { Materia } from "src/app/common/models/tipologiche/materia";
import { MotivoScadenzaAuto } from "src/app/common/models/tipologiche/motivo-scadenza-auto";
import { Oggetto } from "src/app/common/models/tipologiche/oggetto";
import { Priorita } from "src/app/common/models/tipologiche/priorita";
import { Provenienza } from "src/app/common/models/tipologiche/provenienza";
import { Provincia } from "src/app/common/models/tipologiche/provincia";
import { SoggettoPratica } from "src/app/common/models/tipologiche/soggetto-pratica";
import { TipoAtto } from "src/app/common/models/tipologiche/tipo-atto";
import { TipoDocumento } from "src/app/common/models/tipologiche/tipo-documento";
import { TipoFascicolo } from "src/app/common/models/tipologiche/tipo-fascicolo";
import { TipoNatura } from "src/app/common/models/tipologiche/tipo-natura";
import { TipoPersona } from "src/app/common/models/tipologiche/tipo-persona";
import { TipoPetitum } from "src/app/common/models/tipologiche/tipo-petitum";
import { TipoPratica } from "src/app/common/models/tipologiche/tipo-pratica";
import { TipoScadenza } from "src/app/common/models/tipologiche/tipo-scadenza";
import { TipoSocieta } from "src/app/common/models/tipologiche/tipo-societa";
import { HelpersService } from "src/app/core/services/helpers.service";


@Injectable({
  providedIn: 'root'
})
export class CreazionePraticaTipologicheService {

  private tipiPraticaBS$: BehaviorSubject<TipoPratica[]> = new BehaviorSubject<TipoPratica[]>([]);
  tipiPratica$: Observable<TipoPratica[]> = this.tipiPraticaBS$.asObservable();

  private currentMateria: string = "";
  private materiaBS$: BehaviorSubject<Materia[]> = new BehaviorSubject<Materia[]>([]);
  materia$: Observable<Materia[]> = this.materiaBS$.asObservable();

  private currentOggetto: string = "";
  private oggettiBS$: BehaviorSubject<Oggetto[]> = new BehaviorSubject<Oggetto[]>([]);
  oggetti$: Observable<Oggetto[]> = this.oggettiBS$.asObservable();

  private argomentoBS$: BehaviorSubject<Argomento[]> = new BehaviorSubject<Argomento[]>([]);
  argomento$: Observable<Argomento[]> = this.argomentoBS$.asObservable();

  private currentTipoPratica: string = "";
  private tipiFascicoloBS$: BehaviorSubject<TipoFascicolo[]> = new BehaviorSubject<TipoFascicolo[]>([]);
  tipiFascicolo$: Observable<TipoFascicolo[]> = this.tipiFascicoloBS$.asObservable();

  private currentTipoFascicolo: string = "";
  private categorieControparteBS$: BehaviorSubject<Categoria[]> = new BehaviorSubject<Categoria[]>([]);
  categorieControparte$: Observable<Categoria[]> = this.categorieControparteBS$.asObservable();

  private tipiNaturaBS$: BehaviorSubject<TipoNatura[]> = new BehaviorSubject<TipoNatura[]>([]);
  tipiNatura$: Observable<TipoNatura[]> = this.tipiNaturaBS$.asObservable();

  private gradoBS$: BehaviorSubject<Grado[]> = new BehaviorSubject<Grado[]>([]);
  grado$: Observable<Grado[]> = this.gradoBS$.asObservable();

  private currentAutorita: string;
  private autoritagiudiziariaBS$: BehaviorSubject<AutoritaGiudiziaria[]> = new BehaviorSubject<AutoritaGiudiziaria[]>([]);
  autoritagiudiziaria$: Observable<AutoritaGiudiziaria[]> = this.autoritagiudiziariaBS$.asObservable();

  private cittaPerAutoritaGiudiziariaBS$: BehaviorSubject<Comune[]> = new BehaviorSubject<Comune[]>([]);
  cittaPerAutoritaGiudiziaria$: Observable<Comune[]> = this.cittaPerAutoritaGiudiziariaBS$.asObservable();

  private currentProvinciaNascita: string;
  private comuniNascitaBS$: BehaviorSubject<Comune[]> = new BehaviorSubject<Comune[]>([]);
  comuniNascita$: Observable<Comune[]> = this.comuniNascitaBS$.asObservable();

  private currentProvinciaResidenza: string;
  private comuniResidenzaBS$: BehaviorSubject<Comune[]> = new BehaviorSubject<Comune[]>([]);
  comuniResidenza$: Observable<Comune[]> = this.comuniResidenzaBS$.asObservable();

  private provinciaBS$: BehaviorSubject<Provincia[]> = new BehaviorSubject<Provincia[]>([]);
  provincia$: Observable<Provincia[]> = this.provinciaBS$.asObservable();

  private societaBS$: BehaviorSubject<SoggettoPratica[]> = new BehaviorSubject<SoggettoPratica[]>([]);
  societa$: Observable<SoggettoPratica[]> = this.societaBS$.asObservable();

  private tipiPersonaBS$: BehaviorSubject<TipoPersona[]> = new BehaviorSubject<TipoPersona[]>([]);
  tipiPersona$: Observable<TipoPersona[]> = this.tipiPersonaBS$.asObservable();

  private tipiSocietaBS$: BehaviorSubject<TipoSocieta[]> = new BehaviorSubject<TipoSocieta[]>([]);
  tipiSocieta$: Observable<TipoSocieta[]> = this.tipiSocietaBS$.asObservable();

  private categorieAltraParteBS$: BehaviorSubject<Categoria[]> = new BehaviorSubject<Categoria[]>([]);
  categorieAltraParte$: Observable<Categoria[]> = this.categorieAltraParteBS$.asObservable();

  private tipiPetitumBS$: BehaviorSubject<TipoPetitum[]> = new BehaviorSubject<TipoPetitum[]>([]);
  tipiPetitum$: Observable<TipoPetitum[]> = this.tipiPetitumBS$.asObservable();

  private tipiAttoBS$: BehaviorSubject<TipoAtto[]> = new BehaviorSubject<TipoAtto[]>([]);
  tipiAtto$: Observable<TipoAtto[]> = this.tipiAttoBS$.asObservable();

  private tipiProvenienzaBS$: BehaviorSubject<Provenienza[]> = new BehaviorSubject<Provenienza[]>([]);
  tipiProvenienza$: Observable<Provenienza[]> = this.tipiProvenienzaBS$.asObservable();

  private tipiScadenzaBS$: BehaviorSubject<TipoScadenza[]> = new BehaviorSubject<TipoScadenza[]>([]);
  tipiScadenza$: Observable<TipoScadenza[]> = this.tipiScadenzaBS$.asObservable();

  private prioritaScadenzaBS$: BehaviorSubject<Priorita[]> = new BehaviorSubject<Priorita[]>([]);
  prioritaScadenza$: Observable<Priorita[]> = this.prioritaScadenzaBS$.asObservable();

  private motivoScadenzaBS$: BehaviorSubject<MotivoScadenzaAuto[]> = new BehaviorSubject<MotivoScadenzaAuto[]>([]);
  motivoScadenza$: Observable<MotivoScadenzaAuto[]> = this.motivoScadenzaBS$.asObservable();

  private tipiDocumentoBS$: BehaviorSubject<TipoDocumento[]> = new BehaviorSubject<TipoDocumento[]>([]);
  tipiDocumento$: Observable<TipoDocumento[]> = this.tipiDocumentoBS$.asObservable();

  private tipiProvenienzaDocumentoBS$: BehaviorSubject<Provenienza[]> = new BehaviorSubject<Provenienza[]>([]);
  tipiProvenienzaDocumento$: Observable<Provenienza[]> = this.tipiProvenienzaDocumentoBS$.asObservable();

  constructor(private helpers: HelpersService) { }

  //DATI GEN PRATICA
  public getTipiPratica(){
    if(this.tipiPraticaBS$.value.length === 0){
      return this.helpers.getTipiPratica().pipe(
        tap(response => {this.tipiPraticaBS$.next(response)})
      );
    } else {
      return this.tipiPratica$;
    }
  }

  public getSocieta(){
    if(this.societaBS$.value.length === 0){
      return this.helpers.getSoggetti().pipe(
        tap(response => {this.societaBS$.next(response)})
      );
    } else {
      return this.societa$;
    }
  }

  //DATI GEN PRATICA CLASSIFICAZIONE
  public getMateria(){
    if(this.materiaBS$.value.length === 0){
      return this.helpers.getMateria().pipe(
        tap(response => {this.materiaBS$.next(response)})
      );
    } else {
      return this.materia$;
    }
  }

  public getOggetti(materia: string){
    if(this.currentMateria != materia){
      this.currentMateria = materia;
      return this.helpers.getOggetti(materia).pipe(
        tap(response => {this.oggettiBS$.next(response)})
      );
    } else {
      return this.oggetti$;
    }
  }

  public getArgomenti(materia: string, oggetto: string){
    if(this.currentMateria != materia || this.currentOggetto != oggetto){
      this.currentMateria = materia;
      this.currentOggetto = oggetto;
      return this.helpers.getArgomenti(materia,oggetto).pipe(
        tap(response => {this.argomentoBS$.next(response)})
      );
    } else {
      return this.argomento$;
    }
  }


  //DATI GEN FASCICOLO
  public getTipiFascicolo(idPratica: string){
    if(this.currentTipoPratica != idPratica){
      this.currentTipoPratica = idPratica;
      return this.helpers.getTipiFascicolo(idPratica).pipe(
        tap(response => {this.tipiFascicoloBS$.next(response)})
      );
    } else {
      return this.tipiFascicolo$;
    }
  }

  public getTipiNatura(){
    if(this.tipiNaturaBS$.value.length === 0){
      return this.helpers.getTipiNatura().pipe(
        tap(response => {this.tipiNaturaBS$.next(response)})
      );
    } else {
      return this.tipiNatura$;
    }
  }

  public getGradi(){
    if(this.gradoBS$.value.length === 0){
      return this.helpers.getGradi().pipe(
        tap(response => {this.gradoBS$.next(response)})
      );
    } else {
      return this.grado$;
    }
  }

  public getAutoritaGiudiziarie(): Observable<AutoritaGiudiziaria[]> {
    if(this.autoritagiudiziariaBS$.value.length === 0) {
      return this.helpers.getAutoritaGiudiziarie().pipe(
        tap(response => this.autoritagiudiziariaBS$.next(response))
      );
    } else {
      return this.autoritagiudiziaria$;
    }
  }

  public getCittaPerAutoritaGiudiziaria(idAutorita: string){
    if(this.currentAutorita != idAutorita){
      this.currentAutorita = idAutorita;
      return this.helpers.getCittaPerAutoritaGiudiziaria(idAutorita).pipe(
        tap(response => {this.cittaPerAutoritaGiudiziariaBS$.next(response)})
      );
    } else {
      return this.cittaPerAutoritaGiudiziaria$;
    }
  }

  //ANAGRAFICA PARTI
  public getComuniNascita(idProvincia: string){
    if(this.currentProvinciaNascita != idProvincia){
      this.currentProvinciaNascita = idProvincia;
      return this.helpers.getCittaByProvincia(idProvincia).pipe(
        tap(response => {this.comuniNascitaBS$.next(response)})
      );
    } else {
      return this.comuniNascita$;
    }
  }

  public getComuniResidenza(idProvincia: string){
    if(this.currentProvinciaResidenza != idProvincia){
      this.currentProvinciaResidenza = idProvincia;
      return this.helpers.getCittaByProvincia(idProvincia).pipe(
        tap(response => {this.comuniResidenzaBS$.next(response)})
      );
    } else {
      return this.comuniResidenza$;
    }
  }

  public getProvince(){
    if(this.provinciaBS$.value.length === 0){
      return this.helpers.getProvince().pipe(
        tap(response => {this.provinciaBS$.next(response)})
      );
    } else {
      return this.provincia$;
    }
  }

  public getTipiPersona(): Observable<any> {
    if(this.tipiPersonaBS$.value.length === 0){
      return this.helpers.getTipiPersona().pipe(
        tap(response => this.tipiPersonaBS$.next(response))
        );
    } else {
      return this.tipiPersona$;
    }
  }

  public getTipiSocieta(){
    if(this.tipiSocietaBS$.value.length === 0){
      return this.helpers.getTipiSocieta().pipe(
        tap(response => {this.tipiSocietaBS$.next(response)})
      );
    } else {
      return this.tipiSocieta$;
    }
  }

  //PARTI
  public getCategorieControparte(idFascicolo: string){
    if(this.currentTipoFascicolo != idFascicolo){
      this.currentTipoFascicolo = idFascicolo;
      return this.helpers.getCategorieControparte(idFascicolo).pipe(
        tap(response => {this.categorieControparteBS$.next(response)})
      );
    } else {
      return this.categorieControparte$;
    }
  }

  //SOGGETTI TERZI
  public getCategorieAltraParte(){
    if(this.categorieAltraParteBS$.value.length === 0){
      return this.helpers.getCategorieAltraParte().pipe(
        tap(response => {this.categorieAltraParteBS$.next(response)})
      );
    } else {
      return this.categorieAltraParte$;
    }
  }

  //DATI ECONOMICI
  public getTipiPetitum(){
    if(this.tipiPetitumBS$.value.length === 0){
      return this.helpers.getTipiPetitum().pipe(
        tap(response => {this.tipiPetitumBS$.next(response)})
      );
    } else {
      return this.tipiPetitum$;
    }
  }

  //ATTO
  public getTipiAtto(){
    if(this.tipiAttoBS$.value.length === 0){
      return this.helpers.getTipiAtto().pipe(
        tap(response => {this.tipiAttoBS$.next(response)})
      );
    } else {
      return this.tipiAtto$;
    }
  }

  public getTipiProvenienza(){
    if(this.tipiProvenienzaBS$.value.length === 0){
      return this.helpers.getTipiProvenienza().pipe(
        tap(response => {this.tipiProvenienzaBS$.next(response)})
      );
    } else {
      return this.tipiProvenienza$;
    }
  }

  //ADEMPIMENTI

  public getTipiScadenza(){
    if(this.tipiScadenzaBS$.value.length === 0){
      return this.helpers.getTipiScadenza().pipe(
        tap(response => {this.tipiScadenzaBS$.next(response)})
      );
    } else {
      return this.tipiScadenza$;
    }
  }

  getPrioritaScadenza(){
    if(this.prioritaScadenzaBS$.value.length === 0){
      return this.helpers.getPrioritaScadenza().pipe(
        tap(response => {this.prioritaScadenzaBS$.next(response)})
      );
    } else {
      return this.prioritaScadenza$;
    }
  }

  getMotivoScadenza(){
    if(this.motivoScadenzaBS$.value.length === 0){
      return this.helpers.getMotiviScadenzaAutomatica().pipe(
        tap(response => {this.motivoScadenzaBS$.next(response)})
      );
    } else {
      return this.motivoScadenza$;
    }
  }

  //DOCUMENTAZIONE ALLEGATA
  public getTipiDocumenti(){
    if(this.tipiDocumentoBS$.value.length === 0){
      return this.helpers.getTipiDocumenti().pipe(
        tap(response => {this.tipiDocumentoBS$.next(response)})
      );
    } else {
      return this.tipiDocumento$;
    }
  }


  public getTipiProvenienzaDocumento(){
    if(this.tipiProvenienzaDocumentoBS$.value.length === 0){
      return this.helpers.getTipiProvenienzaDocumento().pipe(
        tap(response => {this.tipiProvenienzaDocumentoBS$.next(response)})
      );
    } else {
      return this.tipiProvenienzaDocumento$;
    }
  }


}
